// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a2d75d8c","247":"c653a50b","312":"8530a3a2","627":"c4d24951","768":"aef7cc81","834":"fc04a1ef","867":"a3eefece","923":"88d013ab","938":"79cb1ee6"}[chunkId] + ".chunk.js";
};